<template>
    <svg
        @click="clicked"
            @mouseout="mouseover"
            @mouseleave="mouseleave"
            @mouseenter="mouseenter"
            @mousedown="mousedown"
            width="18" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.5 1H14.5C15.325 1 16 1.675 16 2.5V11.5C16 12.325 15.325 13 14.5 13H2.5C1.675 13 1 12.325 1 11.5V2.5C1 1.675 1.675 1 2.5 1Z" stroke="#858585" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16 2.5L8.5 7.75L1 2.5" stroke="#858585" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
<script>
export default {
    props:["color"],
    methods: {
        clicked() {
            this.$emit('clicked')
        },
        mouseover() {
            this.$emit('mouseover')
        },
        mouseleave() {
            this.$emit('mouseleave')
        },
        mousedown() {
            this.$emit('mousedown')
        },
        mouseenter() {
            this.$emit('mouseenter')
        },
    }
}
</script>